import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';

import { Typography } from '~/packages/common-frontend/components/Typography';

type IbsApiReExecuteConfirmModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
};

export const IbsApiReExecuteConfirmModal = ({
  isOpen,
  isLoading,
  onConfirm,
  onCancel,
}: IbsApiReExecuteConfirmModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <ModalOverlay />
      <ModalContent p="5">
        <ModalHeader>Re-Execute IBS API</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Typography variant="base-muted">
            An IBS API has previously been successfully executed for this
            funding component. Please ensure this re-execution is the desired
            action and IBS has been managed accordingly.
          </Typography>
        </ModalBody>

        <ModalFooter gap="0.5rem" mt="1rem">
          <Button
            colorScheme="v2-aurora"
            onClick={onCancel}
            variant="secondary"
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            colorScheme="v2-aurora"
            isLoading={isLoading}
            onClick={async () => {
              await onConfirm();
              onCancel();
            }}
          >
            Confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
